export default "__VITE_ASSET__7a436af1__"